import SubTitle from "../../components/template/SubTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "../../components/utils/Utils";
import { COLUMN_NAME, getComparison } from "./utils";

const EvaluationComparisonSummaryColumn = ({ evaluation1, evaluation2 }) => (
    <div>
        {evaluation1 && Object.keys(evaluation1).length !== 0 &&
            <div className="p-2">
                <div className="text-lg flex justify-between items-center mb-1">
                    <SubTitle title="Summary" />
                    <a
                        href={`/post-action/models/${evaluation1.general_model_id}/merge-rules/${evaluation1.merge_rule_id}/evaluations`}
                        target="_blank" rel="noopener noreferrer"
                        className="flex items-center gap-1 bg-violet-100 text-sm border border-violet-500 text-violet-500 hover:bg-violet-200 px-2 py-1 rounded-xl"
                    >View Evaluation <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>
                </div>
                {Object.entries(evaluation1.threshold_evaluation_summary).map(([k, v], i) => (
                    <div key={i} className={classNames("flex justify-between py-2", i === 0 ? 'border-y' : 'border-b')}>
                        <p className="font-bold">{COLUMN_NAME[k]}</p>
                        <p className={classNames(
                            evaluation2 && evaluation2.hasOwnProperty('threshold_evaluation_summary') && getComparison(v, evaluation2.threshold_evaluation_summary[k])
                        )}>{v}</p>
                    </div>
                ))}
            </div>
        }
    </div>
);

const EvaluationComparisonSummary = ({ evaluation1, evaluation2 }) => {
    return (
        <div className="grid grid-cols-2 gap-2 text-sm">
            <EvaluationComparisonSummaryColumn
                evaluation1={evaluation1}
                evaluation2={evaluation2}
            />
            <EvaluationComparisonSummaryColumn
                evaluation1={evaluation2}
                evaluation2={evaluation1}
            />
        </div>
    );
}


export default EvaluationComparisonSummary